import { Guid } from "guid-typescript";
import ServerError from "./ServerError";

class NotifiablePromise<T> extends Promise<T> {
    private status: boolean;
    private outcome: boolean;
    request: XMLHttpRequest;
    data: any;
    result: T;
    error: ServerError;
    private resolveHanlders: ((result: T) => void)[];
    private rejectHanlders: ((error: ServerError) => void)[];
    private progressHandlers: ((progess: ProgressEvent) => void)[];
    private finallyHanlders: ((result: T, error: ServerError) => void)[];

    constructor(executor: (resolve: (result: T) => void, reject: (error: ServerError) => void, notify: (progess: ProgressEvent) => void, initialise: (data: XMLHttpRequest | any) => void) => void) {
        super(()=>{});

        this.status = false;
        this.outcome = false;
        this.result = null;
        this.error = null;

        this.resolveHanlders = [];
        this.rejectHanlders = [];
        this.progressHandlers = [];
        this.finallyHanlders = [];

        executor?.(this.resolve.bind(this), this.reject.bind(this), this.notify.bind(this), this.initialise.bind(this));
    }

    initialise(data: any) {
        if (data instanceof XMLHttpRequest)
            this.request = data;
        
        this.data = data;
    }
    resolve(result: T) {
        this.status = true;
        this.outcome = true;
        this.result = result;
        this.resolveHanlders.forEach(handler => handler(result));
        this.finallyHanlders.forEach(handler => handler(result, null));
    }
    notify(progess: ProgressEvent) {
        this.progressHandlers.forEach(handler => handler(progess));
    }
    reject(error: ServerError) {
        this.status = true;
        this.outcome = false;
        this.error = error;
        this.rejectHanlders.forEach(handler => handler(error));
        this.finallyHanlders.forEach(handler => handler(null, error));
    }

    then<TResult1 = T, TResult2 = never>(onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | undefined | null, onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | undefined | null): NotifiablePromise<TResult1 | TResult2> {
        if (this.status) {
            if (this.outcome)
                onfulfilled(this.result);
            else
                onrejected(this.error);
        } else {
            if (onfulfilled)
                this.resolveHanlders.push(onfulfilled);
            if (onrejected)
                this.rejectHanlders.push(onrejected);
        }

        return this as unknown as NotifiablePromise<TResult1>;
    }
    progress(handler: (progress: ProgressEvent) => void): NotifiablePromise<T> {
        if (!this.status)
            this.progressHandlers.push(handler);

            return this;
    }
    catch<TResult = never>(onrejected?: ((reason: any) => TResult | PromiseLike<TResult>) | undefined | null): NotifiablePromise<T | TResult> {
        if (this.status) {
            if (!this.outcome)
                onrejected(this.error);
        } else
            this.rejectHanlders.push(onrejected);

        return this;
    }
    finally(handler: (result: T, error: ServerError) => void): NotifiablePromise<T> {
        if (this.status)
            handler(this.result, this.error);
        else
            this.finallyHanlders.push(handler);

        return this;
    }
    abort() {
        if (this.request?.abort)
            this.request?.abort?.();
        else
            this.reject({
                id: Guid.create().toString(),
                message: "Operation aborted",
                exceptionMessage: "Operation aborted",
                reason: "Operation aborted"
            } as ServerError)
    }
}

export default NotifiablePromise;